import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * Banner shown when the current session is "login as user" (impersonation).
 * Renders above main content; includes a Log out button that runs normal logout.
 */
const LoginAsUserBanner = () => {
  const { logout } = useAuth();
  const { replace } = useTextReplacement();

  const isLoginAsUser = typeof window !== 'undefined' && localStorage.getItem('login_as_user_active') === 'true';
  const displayName = typeof window !== 'undefined' ? (localStorage.getItem('login_as_user_name') || replace('this user')) : replace('this user');

  if (!isLoginAsUser) return null;

  return (
    <div
      className="flex items-center justify-between gap-4 px-4 py-2 bg-amber-100 dark:bg-amber-900/40 text-amber-900 dark:text-amber-200 border-b border-amber-200 dark:border-amber-800"
      role="status"
      aria-live="polite"
    >
      <span className="text-sm font-medium">
        {replace('Viewing as')} <strong>{displayName}</strong>. {replace('Log out to return to your account.')}
      </span>
      <button
        type="button"
        onClick={() => logout()}
        className="shrink-0 px-3 py-1.5 text-sm font-medium bg-amber-200 dark:bg-amber-800 hover:bg-amber-300 dark:hover:bg-amber-700 text-amber-900 dark:text-amber-100 rounded transition-colors"
      >
        {replace('Log out')}
      </button>
    </div>
  );
};

export default LoginAsUserBanner;
